"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var ExtComp_1 = __importDefault(require("../modules/ExtComp"));
var ExtLogger_1 = __importDefault(require("../modules/ExtLogger"));
var sharedInstance = null;
var CommonExtComp = /** @class */ (function () {
    function CommonExtComp() {
    }
    CommonExtComp.getSharedInstance = function () {
        if (sharedInstance) {
            return Promise.resolve(sharedInstance);
        }
        else {
            sharedInstance = new CommonExtComp();
            return Promise.resolve(sharedInstance);
        }
    };
    CommonExtComp.prototype.init = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var err_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.extComp = new ExtComp_1["default"]();
                        this.adapter = options.adapter;
                        this.logger = ExtLogger_1["default"].getGlobalLogger(function (logContent) { return _this.adapter.log(logContent); });
                        this.logger.info('欢迎使用中台小程序，努力初始化中...');
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, , 6]);
                        this.logger.debug('中台小程序组件初始化');
                        return [4 /*yield*/, this.extComp.init(this.adapter)];
                    case 2:
                        _a.sent();
                        this.logger.debug('拉取小程序列表');
                        return [4 /*yield*/, this.extComp.fetchExtMainList()];
                    case 3:
                        _a.sent();
                        this.logger.debug('中台小程序组件初始化完成', { extMainList: this.extComp.extMainList });
                        return [4 /*yield*/, this.adapter.extEndpointModulesManager.renderAll(this.extComp.extMainList, this.adapter)];
                    case 4:
                        _a.sent();
                        this.logger.debug('Endpoints初始化完毕', { commonEndpointList: this.adapter.extEndpointModulesManager.extEndpointModuleList });
                        this.logger.info('中台小程序初始化完成，成功初始化小程序endpoint', { commonEndpointList: this.adapter.extEndpointModulesManager.getSummary() });
                        return [3 /*break*/, 6];
                    case 5:
                        err_1 = _a.sent();
                        this.logger.warn('中台小程序初始化失败', { err: err_1.message });
                        if (process.env.NODE_ENV === 'development') {
                            throw err_1;
                        }
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    return CommonExtComp;
}());
exports["default"] = CommonExtComp;
